import type { FlowVariant } from "./types";

const FLOW_ALIASES: Record<string, FlowVariant> = {
  a: "a",
  b: "b",
  roman: "a",
  history: "a",
  flow_a: "a",
  flowa: "a",
  science: "b",
  general_science: "b",
  flow_b: "b",
  flowb: "b"
};

const normalize = (value: string): string => {
  return value.toLowerCase().replace(/[^a-z0-9]/g, "_");
};

const fromAlias = (value: string | null): FlowVariant | null => {
  if (!value) {
    return null;
  }

  const direct = FLOW_ALIASES[normalize(value)];
  return direct ?? null;
};

export const resolveFlowFromUrl = (
  urlLike: URL | string = window.location.href
): FlowVariant => {
  const url = typeof urlLike === "string" ? new URL(urlLike) : urlLike;

  // Query wins for testing (`?flow=b`, `?variant=a`, `?type=science`).
  const queryFlow =
    fromAlias(url.searchParams.get("flow")) ??
    fromAlias(url.searchParams.get("variant")) ??
    fromAlias(url.searchParams.get("type"));
  if (queryFlow) {
    return queryFlow;
  }

  // Then try path segments (`/roman`, `/science`, `/flow/a`).
  const pathSegments = url.pathname.split("/").filter(Boolean);
  for (let index = pathSegments.length - 1; index >= 0; index -= 1) {
    const matched = fromAlias(pathSegments[index]);
    if (matched) {
      return matched;
    }
  }

  return "a";
};
